var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsatisfeito(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 871,
    height: 871,
    viewBox: "0 0 871 871",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14_64708)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_64708",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: 0,
    width: 872,
    height: 871
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M870.846 0H-0.00585938V870.852H870.846V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_64708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M435.39 104.631C618.137 104.631 766.282 252.776 766.282 435.523C766.282 618.27 618.137 766.415 435.39 766.415C252.643 766.415 104.498 618.27 104.498 435.523C104.498 252.776 252.643 104.631 435.39 104.631Z",
    fill: "url(#paint0_linear_14_64708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.422 436.772C727.869 603.255 593.756 736.19 430.866 733.693C267.977 731.197 138 594.215 140.551 427.733C143.103 261.25 277.217 128.315 440.106 130.812C602.995 133.308 732.973 270.29 730.422 436.772Z",
    fill: "url(#paint1_radial_14_64708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.996 586.415C155.996 632.029 236.635 706.501 245.69 702.94C267.831 694.233 292.692 673.317 292.692 627.702C292.692 574.833 220.601 486.588 203.802 458.28C201.297 454.058 195.214 453.999 192.637 458.177C175.84 485.412 155.996 526.396 155.996 586.415Z",
    fill: "url(#paint2_linear_14_64708)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.752 634.442C490.572 613.824 458.906 597.375 433.992 597.375C409.038 597.375 377.481 613.824 358.301 634.442C340.88 653.17 339.533 670.493 345.195 672.67C352.306 675.405 383.355 643.648 433.992 643.103C484.63 643.648 515.679 675.405 522.79 672.67C528.452 670.493 527.173 653.17 509.752 634.442Z",
    fill: "#FEDD78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.548 617.362C485.368 596.743 458.908 580.293 433.994 580.293C409.04 580.293 382.619 596.743 363.439 617.362C346.018 636.09 339.534 663.742 345.196 665.919C352.307 668.654 383.357 628.262 433.994 627.717C484.631 628.262 515.68 668.654 522.791 665.919C528.453 663.742 521.969 636.09 504.548 617.362Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M504.548 627.522C485.368 606.904 458.908 590.455 433.994 590.455C409.04 590.455 382.619 606.904 363.439 627.522C346.018 646.25 339.534 663.573 345.196 665.75C352.307 668.485 383.357 636.728 433.994 636.183C484.631 636.728 515.68 668.485 522.791 665.75C528.453 663.573 521.969 646.25 504.548 627.522Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.437 665.386C520.829 658.172 514.46 647.974 504.536 637.321C485.363 616.709 458.909 601.941 433.995 601.941C409.03 601.941 382.626 616.709 363.435 637.321C353.526 647.974 347.16 658.172 344.551 665.386C340.096 662.117 346.736 645.469 363.435 627.515C382.626 606.902 409.03 590.457 433.995 590.457C458.909 590.457 485.363 606.902 504.536 627.515C521.235 645.469 527.892 662.117 523.437 665.386Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.347 457.172C373.347 482.922 356.023 503.796 334.651 503.796C313.28 503.796 295.955 482.922 295.955 457.172C295.955 431.423 313.28 410.549 334.651 410.549C356.023 410.549 373.347 431.423 373.347 457.172Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.019 457.172C575.019 482.922 557.695 503.796 536.323 503.796C514.952 503.796 497.627 482.922 497.627 457.172C497.627 431.423 514.952 410.549 536.323 410.549C557.695 410.549 575.019 431.423 575.019 457.172Z",
    fill: "#EAAC1F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.347 473.93C373.347 499.68 356.023 520.554 334.651 520.554C313.28 520.554 295.955 499.68 295.955 473.93C295.955 448.181 313.28 427.307 334.651 427.307C356.023 427.307 373.347 448.181 373.347 473.93Z",
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.019 473.93C575.019 499.68 557.695 520.554 536.323 520.554C514.952 520.554 497.627 499.68 497.627 473.93C497.627 448.181 514.952 427.307 536.323 427.307C557.695 427.307 575.019 448.181 575.019 473.93Z",
    fill: "#FFE0A0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.659 418.338C354.694 418.338 370.938 439.212 370.938 464.961C370.938 490.711 354.694 511.585 334.659 511.585C314.625 511.585 298.381 490.711 298.381 464.961C298.381 439.212 314.625 418.338 334.659 418.338Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.931 464.967C370.931 467.015 370.826 469.034 370.614 471.006C368.338 448.091 353.102 430.407 334.656 430.407C316.21 430.407 300.974 448.091 298.698 471.006C298.486 469.034 298.381 467.015 298.381 464.967C298.381 439.211 314.623 418.344 334.656 418.344C354.689 418.344 370.931 439.211 370.931 464.967Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M536.331 418.338C556.366 418.338 572.61 439.212 572.61 464.961C572.61 490.711 556.366 511.585 536.331 511.585C516.296 511.585 500.053 490.711 500.053 464.961C500.053 439.212 516.296 418.338 536.331 418.338Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.603 464.967C572.603 467.015 572.498 469.034 572.286 471.006C570.01 448.091 554.774 430.407 536.328 430.407C517.882 430.407 502.644 448.091 500.37 471.006C500.158 469.034 500.053 467.015 500.053 464.967C500.053 439.211 516.295 418.344 536.328 418.344C556.361 418.344 572.603 439.211 572.603 464.967Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.715 359.495C688.326 361.6 681.534 364.071 676.07 365.167C652.394 369.922 607.058 361.637 576.586 332.822C533.191 291.789 548.665 263.952 558.245 272.26C567.824 280.568 600.156 321.303 653.862 333.787C668.252 337.133 680.884 333.584 688.689 336.138C698.999 339.512 699.493 351.76 690.715 359.495Z",
    fill: "#FFE2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M691.413 350.85C689.141 353.082 682.839 355.997 677.375 357.094C653.7 361.849 612.36 356.129 581.887 327.315C538.492 286.28 548.664 263.952 558.243 272.26C567.823 280.567 599.967 316.119 653.673 328.603C668.064 331.949 678.608 332.729 686.413 335.283C696.723 338.657 697.65 344.724 691.413 350.85Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.218 348.802C691.782 347.383 689.522 346.121 686.421 345.105C678.608 342.547 668.061 341.759 653.678 338.413C599.964 325.939 567.817 290.375 558.251 282.071C555.15 279.391 551.997 279.899 550.595 283.21C547.898 272.085 553.153 267.846 558.251 272.261C567.817 280.565 599.964 316.128 653.678 328.602C668.061 331.948 678.608 332.737 686.421 335.277C695.566 338.273 697.318 343.388 693.218 348.802Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.567 357.088C178.876 359.281 185.57 362.003 190.989 363.305C214.47 368.943 260.086 362.359 291.615 334.705C336.515 295.324 322.091 266.927 312.209 274.871C302.325 282.814 268.492 322.312 214.356 332.778C199.85 335.583 187.361 331.564 179.467 333.824C169.038 336.811 168.085 349.031 176.567 357.088Z",
    fill: "#FFE2A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.189 348.424C178.377 350.74 184.565 353.888 189.983 355.19C213.464 360.827 254.99 356.659 286.519 329.005C331.418 289.624 322.088 266.93 312.205 274.873C302.321 282.816 268.87 317.14 214.734 327.606C200.228 330.411 189.661 330.794 181.767 333.056C171.338 336.043 170.185 342.068 176.189 348.424Z",
    fill: "#974800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.46 346.306C175.949 344.941 178.256 343.766 181.392 342.867C189.295 340.604 199.864 340.209 214.363 337.405C268.506 326.949 301.96 292.614 311.831 284.674C315.029 282.111 318.16 282.736 319.437 286.098C322.55 275.082 317.458 270.65 312.198 274.87C302.328 282.81 268.872 317.147 214.729 327.601C200.23 330.406 189.663 330.798 181.76 333.044C172.508 335.696 170.565 340.744 174.46 346.306Z",
    fill: "#632900"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.39 104.631C618.137 104.631 766.282 252.776 766.282 435.523C766.282 618.27 618.137 766.415 435.39 766.415C252.643 766.415 104.498 618.27 104.498 435.523C104.498 252.776 252.643 104.631 435.39 104.631Z",
    stroke: "#E76900",
    strokeWidth: 10.2512,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.504 620.107C127.646 659.495 159.692 691.308 199.078 691.166C238.465 691.024 270.279 658.98 270.138 619.592C269.996 580.206 198.306 449.186 198.306 449.186C198.306 449.186 127.362 580.721 127.504 620.107Z",
    fill: "#38A4E0"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.67 658.051L254.676 658.03C256.454 651.34 257.57 654.598 257.447 647.207C256.769 608.818 228.677 578.185 194.683 578.788C172.502 579.177 153.336 592.761 142.858 612.801C136.106 631.112 135.28 641.3 141.313 658.703C141.334 658.708 141.327 658.728 141.322 658.749C144.99 664.367 149.598 669.409 155.215 673.701C161.483 678.547 169.028 682.434 177.881 685.068C201.172 691.979 220.815 684.996 235.413 675.089C243.411 669.67 249.91 663.398 254.67 658.051Z",
    fill: "#92F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.893 649.931C248.33 617.793 224.814 592.155 196.383 592.66C167.93 593.159 145.337 619.62 145.905 651.738C146.136 664.907 149.996 666.595 156.711 676.235C162.979 681.08 170.523 684.966 179.375 687.599C202.667 694.51 222.309 687.529 236.908 677.622C244.485 667.31 249.156 664.397 248.893 649.931Z",
    fill: "#92F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.049 605.496C172.898 605.903 154.503 627.43 154.962 653.579C155.421 679.728 174.331 690.203 197.482 689.796C220.634 689.39 239.262 678.253 238.803 652.104C238.344 625.955 219.201 605.09 196.049 605.496Z",
    fill: "#92F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M197.246 622.34C180.11 622.642 166.494 638.577 166.834 657.93C167.174 677.284 181.111 682.338 198.246 682.037C215.382 681.735 229.23 676.192 228.89 656.839C228.551 637.486 214.381 622.039 197.246 622.34Z",
    fill: "#92F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.127 644.477C186.749 644.642 179.298 653.363 179.484 663.953C179.67 674.543 187.191 672.604 196.568 672.439C205.946 672.275 213.629 673.946 213.443 663.356C213.257 652.765 205.505 644.312 196.127 644.477Z",
    fill: "#92F5FF"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.453 591.798C156.534 614.17 176.486 632.241 198.858 632.16C221.23 632.08 241.053 613.879 240.972 591.507C240.904 572.522 210.309 491.452 201.046 467.344C200.125 464.944 196.735 464.953 195.824 467.356C186.661 491.52 156.385 572.811 156.453 591.798Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127.504 620.106C127.504 659.494 159.692 691.309 199.078 691.167C238.465 691.025 270.137 658.981 270.137 619.593C270.137 573.942 220.599 486.59 203.8 458.282C201.294 454.06 195.212 454.001 192.635 458.179C175.837 485.414 127.504 568.283 127.504 620.106Z",
    stroke: "#1C6DBF",
    strokeWidth: 10.2512,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.666 558.531L232.339 560.539",
    stroke: "white",
    strokeWidth: 7.68838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.553 534.271L226.951 544.436",
    stroke: "white",
    strokeWidth: 7.68838,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_64708",
    x1: 434.058,
    y1: 135.449,
    x2: 434.122,
    y2: 752.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5AB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ED8700"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_14_64708",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(424.412 162.105) scale(578.149 578.149)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#FEFEE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FDEE8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FCDE36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#F5B820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EE910A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_14_64708",
    x1: 429.681,
    y1: 127.485,
    x2: 432.062,
    y2: 752.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCF18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F5AB0C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#ED8700"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14_64708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 870.852,
    height: 870.852,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsatisfeito);
export default __webpack_public_path__ + "static/media/insatisfeito.f82b674f52fd59116eeb1846018664bc.svg";
export { ForwardRef as ReactComponent };